<app-loader *ngIf="_commonService.loaderInfo.showLoader"></app-loader>

<app-top-nav *ngIf="_commonService.layoutViewModel.showTopNav"></app-top-nav>

<router-outlet></router-outlet>

<app-footer *ngIf="_commonService.layoutViewModel.showFooter"></app-footer>


